import { darken, transparentize } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';

import {
	IconMenu,
	IconInfo,
	IconCall,
	IconCheck,
	IconInvalid,
	IconConnectionError,
	QuestionMark,
	IconDocument,
} from './../../easyclaim.app.assets/index';
import { Circle, FadeInBottom } from './../index';

export const StyledIconMenu = styled(IconMenu)<{ color?: string }>`
	color: ${(props) => (props.color ? props.color : props.theme.colors.secondary)};
	height: 2rem;
`;

export const StyledCallIcon = styled(IconCall)`
	height: 4rem;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.success};
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export const StyledIconCheck = styled(IconCheck)`
	color: ${(p) => p.theme.colors.success};
	height: 1.5rem;
`;

export const StyledIconInvalid = styled(IconInvalid)`
	color: ${(p) => p.theme.colors.danger};
	height: 1.5rem;
`;

export const StyledIconConnectionError = styled(IconConnectionError)`
	color: ${(p) => p.theme.colors.danger};
	height: 1.5rem;
`;

export const StyledIconQuestionMark = styled(QuestionMark)`
	color: ${(p) => p.theme.colors.warning};
	height: 1.5rem;
`;

export const StyledInfoIcon = styled(IconInfo)`
	height: 1.1rem;
	vertical-align: text-bottom;
	color: ${(props) => darken(0.2, props.theme.colors.secondary)};
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	cursor: pointer;
`;

export const StyledCalculationIcon = styled(IconDocument)`
	height: 2rem;
	width: 2rem;
	flex-grow: 0;
	flex-shrink: 0;
	margin-right: 0.35rem;
`;

export const Message = styled.div`
	margin: 2rem;
	text-align: center;
`;

export const CenteredCircle = styled(Circle)`
	margin: 2rem auto;
	animation: ${css`
			${FadeInBottom}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) forwards;
`;

export const DetailContainer = styled.div`
	text-align: left;
	display: flex;
	flex-direction: column;
	margin-bottom: 1rem;
`;

export const GrowingDetailContainer = styled.div`
	text-align: left;
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	margin-bottom: 1rem;
`;

export const DetailsContainer = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 360px;
`;

export const MenuContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const HamburgerContainer = styled.div`
	display: flex;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`;

export const Header = styled.header`
	padding: 0.5rem 1rem 1rem 1rem;
	border-bottom: 1px solid ${(p) => transparentize(0.8, p.theme.colors.secondary)};
`;

export const Main = (props) => (
	<main style={props.style} className={props.className}>
		{props.children}
	</main>
);

export const Link = styled.div`
	display: flex;
	align-items: center;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	&:not(:last-child) {
		margin-bottom: 1rem;
	}
`;
export const LinkContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 2rem 0;
	flex-grow: 1;
	flex-shrink: 1;
	justify-content: flex-start;
	cursor: pointer;
`;
